







import { Component, Vue,Prop } from 'vue-property-decorator'
import {MDCTopAppBar} from '@material/top-app-bar/index'
@Component({})
export default class MdcTopAppBar extends Vue{
  mdcComponent!:MDCTopAppBar
  @Prop({default:false}) fixed!:boolean
  @Prop({default:false}) short!:boolean
  @Prop({default:false}) shortCollapsed!:boolean
  @Prop({default:false}) prominent!:boolean
  @Prop({default:false}) dense!:boolean
  get cssClass(){
    return {
      'mdc-top-app-bar--fixed':this.fixed,
      'mdc-top-app-bar--short':this.short,
      'mdc-top-app-bar--short-collapsed':this.shortCollapsed,
      'mdc-top-app-bar--prominent':this.prominent,
      'mdc-top-app-bar--dense':this.dense,
    }
  }
  mounted() {
    const root =(this.$refs.root as Element)
    this.mdcComponent = new MDCTopAppBar(root)
  }
  beforeDestroy() {
    this.mdcComponent.destroy()
  }
}
